import moment from 'moment-timezone';

export const UK_TIMEZONE = 'Europe/London';

// Session/booking instants are stored and generated in UK time (see api/utils/Session.utils.js),
// so they must always be displayed in UK time regardless of the viewer's device timezone -
// otherwise the same session shows a different time to a customer browsing from abroad.
const ukMoment = (date) => moment(date).tz(UK_TIMEZONE);

export default ukMoment;
